var exports = {
  "HM": "UserAreaSkeleton.module__userArea___RDBoaX",
  "nd": "UserAreaSkeleton.module__panel___RDBoaX",
  "zl": "UserAreaSkeleton.module__voicePanel___RDBoaX",
  "Qs": "UserAreaSkeleton.module__content___RDBoaX",
  "D_": "UserAreaSkeleton.module__identity___RDBoaX",
  "Ky": "UserAreaSkeleton.module__identityText___RDBoaX",
  "S7": "UserAreaSkeleton.module__nameRow___RDBoaX",
  "jf": "UserAreaSkeleton.module__statusRow___RDBoaX",
  "ne": "UserAreaSkeleton.module__controls___RDBoaX",
};

module.exports = exports;
